import { useEffect } from 'react';

/** Quanto o aviso de sucesso fica na tela (`DP-PT-019`). O de erro só sai pelo operador. */
const DURACAO_DO_SUCESSO_MS = 5_000;

export interface AvisoDaTela {
    tipo: 'sucesso' | 'erro';
    texto: string;
}

export function Aviso({ aviso, aoFechar }: { aviso: AvisoDaTela; aoFechar: () => void }) {
    useEffect(() => {
        if (aviso.tipo !== 'sucesso') return undefined;
        const espera = setTimeout(aoFechar, DURACAO_DO_SUCESSO_MS);
        return () => clearTimeout(espera);
    }, [aviso, aoFechar]);

    return (
        <div className={`aviso aviso-${aviso.tipo}`} role={aviso.tipo === 'sucesso' ? 'status' : 'alert'}>
            <span>{aviso.texto}</span>
            <button type="button" className="fechar-aviso" aria-label="Fechar aviso" onClick={aoFechar}>
                ×
            </button>
        </div>
    );
}
